<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'modificadores', params:{idBusiness: idBusiness}}">
                                {{$t("modificadores")}}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t("modificador")}}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="tituloNumier">
                                <i class="fa fa-building"></i> {{nombreNegocio}}</h2>
                            <hr>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="nameModificador"><strong>{{$t("nombreModificador")}} <span style="color: red">*</span></strong></label>
                                <input type="text" class="form-control"
                                       :class="{'is-valid': modificador.name.length >0 && modificador.name.length <= maxNameModificador,
                                       'is-invalid': modificador.name.length > maxNameModificador}"
                                       id="nameModificador" v-bind:placeholder="$t('introduzcaNombre')"
                                       v-model="modificador.name" ref="name">
                                <input type="hidden" v-model="modificador.xname">
                                <small class="form-text text-muted">{{modificador.name.length}}/50</small>
                            </div>
                        </div>


                        <div class="col-md-4">
                            <div class="form-group">
                                <label><strong>{{$t("grupo")}}</strong></label>
                                <el-select class="select-default"
                                           size="large"
                                           v-model="modificador.idGrupo"
                                           filterable
                                           :placeholder="$t('seleccionaGrupo')">
                                    <el-option v-for="grupo in listGrupos"
                                               class="select-primary"
                                               :value="grupo.id"
                                               :label="grupo.name"
                                               :key="grupo.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="variacion"><strong>{{$t("variacion")}}</strong></label>
                                <vue-numeric currency="€"
                                             id="variacion"
                                             inputmode="decimal"
                                             type="text"
                                             class="form-control"
                                             currency-symbol-position="suffix"
                                             :precision="2"
                                             @keydown.native="$methods.evitarComasDecimales"
                                             v-model=modificador.variacion></vue-numeric>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">

                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("resta")}}</strong>
                                    </label>
                                    <el-switch v-model="modificador.resSum"
                                               active-color="#16C713"
                                               inactive-color="red">
                                    </el-switch>
                                    <label>
                                        <strong>{{$t("suma")}}</strong>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("baja")}}</strong>
                                    </label>
                                    <el-switch v-model="modificador.baja"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <button class="btn btn-primary" v-once-click.once="saveModificador" :disabled="inProgress"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>
                            <router-link :to="{name:'modificadores', params:{idBusiness: idBusiness, 'pag' : pag}}">
                                <button class="btn btn-danger"><i class="fa fa-window-close"></i> {{$t("cancelar")}}
                                </button>
                            </router-link>
                            <el-checkbox v-model="checkReply" border class="checkbox-element">
                                {{$t("replicar")}}
                            </el-checkbox>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <modal name="modalReply" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("replicarModificador")}}</h4>
                </div>
                <div class="modal-body">
                    <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
                           @click="selectAll">
                    <label for="checkSelectAll" class="checkSelectAll">{{$t("seleccionarTodos")}}</label>

                    <div v-for="business in listBusinesses">
                        <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border
                                     class="checkbox-element" style="width: 100%">
                            {{business.establishmentName}}
                        </el-checkbox>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="closeModal()"><i
                            class="fa fa-times-circle"></i> {{$t("cancelar")}}
                    </button>
                    <button class="btn btn-primary" @click="replyModificador"><i class="fa fa-check-circle"></i>
                        {{$t("aceptar")}}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import swal from 'sweetalert2';
    import {Loading} from 'element-ui';
    import {
        Checkbox,
        Switch,
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button
    } from 'element-ui'

    export default {
        props: ['idBusiness', 'idModificador', 'pag'],
        created() {
            this.action = this.idModificador ? this.$t('editar') : this.$t('nuevo');
            this.loadingGeneral = Loading.service({text: this.$t('cargando')});
            this.identificacionNegocio();
            this.getGrupos();


            if (this.idModificador) {
                this.getModificador();
            }


        },

        updated(){

            this.nPeticiones++;

            if(this.idModificador){

                if(this.nPeticiones===3) {

                    this.loadingGeneral.close();
                }
            }
            else{

                if(this.nPeticiones===2) {
                    this.loadingGeneral.close();
                }
            }


        },

        components: {
            [Checkbox.name]: Checkbox,
            [Switch.name]: Switch,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        mounted() {
            this.$refs.name.focus();
        },
        data() {
            return {

                loadingGeneral: null,
                nPeticiones:0,

                modificador: {
                    name: "",
                    idGrupo: 0,
                    variacion: 0,
                    resSum: true,
                    baja: false,
                    xname: ""
                },


                checkSelectAll: false,
                listBusinesses: [],
                checkReply: false,
                maxNameModificador: 50,
                action: "",
                inProgress: false,
                nombreNegocio: "",
                listGrupos: [],

            }
        },
        methods: {
            identificacionNegocio() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'general/identifyBusiness', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.nombreNegocio = response.data.result

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            checkCampos() {
                if (this.modificador.name.length > this.maxNameModificador) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('laLongitudDelNombreNoPuedeSerMayorDe') + this.maxNameModificador + '.',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else if (this.modificador.name === null || this.modificador.name.length === 0) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    return true;
                }
            },
            getGrupos() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'modifiers/getGruposByModifiers', config)
                    .then(function (response) {
                        if (response.data.response) {
                            if (response.data.result.length === 0) {
                                let grupo = {
                                    name: vm.$t('todosMayusculas'),
                                    id: 0
                                };

                                vm.listGrupos.push(grupo);
                            }

                            for (let i = 0; i < response.data.result.length; i++) {

                                if (i === 0) {
                                    let grupo = {
                                        name: vm.$t('todosMayusculas'),
                                        id: 0
                                    };

                                    vm.listGrupos.push(grupo);
                                }


                                let grupo = {
                                    name: response.data.result[i].name,
                                    id: response.data.result[i].id,
                                };

                                vm.listGrupos.push(grupo)

                            }

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.result,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },

            getModificador() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idModificador: this.idModificador,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'modifiers/getModifierById', config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.modificador = response.data.result;
                            vm.modificador.xname = response.data.result.name;

                            vm.loadingGeneral.close();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            saveModificador() {
                if (this.checkCampos()) {
                    this.inProgress = true;

                    var config = {
                        params:{
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        modificador: this.modificador,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = this.idModificador ? "editModifierById" : "newModifier";
                    this.axios.post(this.$store.getters.apiUrl + 'modifiers/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.idModificador ? vm.$t('actualizado') : vm.$t('creado');
                                vm.$notify({
                                    message: vm.$t('modificador') + ' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                if (vm.checkReply) {

                                    if (!vm.idModificador) {
                                        vm.modificador.xname = vm.modificador.name;
                                    }

                                    vm.axios.get(vm.$store.getters.apiUrl + 'general/getBusinessesByUserReplicado', config)
                                        .then(function (response) {
                                            if (response.data.response) {
                                                vm.listBusinesses = response.data.result;
                                                vm.$modal.show('modalReply');
                                            } else {
                                                swal({
                                                    title: vm.$t('atencion'),
                                                    text: response.data.message,
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    type: 'error'
                                                });
                                            }

                                        });

                                } else {
                                    vm.$router.push({
                                        name: 'modificadores',
                                        params: {idBusiness: vm.idBusiness, 'pag': vm.pag}
                                    })
                                }

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
                }
            },
            replyModificador() {
                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                let xbusinesses = new Array();
                this.listBusinesses.forEach(function (business) {
                    if (business.checked && business.id!==vm.idBusiness) {
                        xbusinesses.push(business);
                    }

                });

                var params = {
                    listBusinesses: xbusinesses,
                    modificador: this.modificador,
                    jwt: this.$store.getters.jwt
                };
                this.axios.post(this.$store.getters.apiUrl + 'modifiers/replyModifiers', params, config)
                    .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                            vm.closeModal();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
            },
            closeModal() {
                this.$modal.hide('modalReply');
                this.$router.push({name: 'modificadores', params: {idBusiness: this.idBusiness, 'pag': this.pag}})
            },
            selectAll() {
                if (this.checkSelectAll) {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = false;
                    });
                } else {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = true;
                    });
                }
            }
        }

    }
</script>

<style scoped>
    .card {
        padding: 20px;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Widgets/Modificadores/ModificadorForm.vue